import { ReactNode } from 'react'
import { Button } from '~/components/elements/Button'
import { MoreHorizIcon } from '~/components/icons/generated/MoreHorizIcon'
import { Popup } from '~/components/modules/Popup'
import { useBinary } from '~/hooks/useBinary'

type Props = {
  children: ReactNode
}

export const MoreHorizPopup: React.FC<Props> = ({ children }) => {
  const [isOpenPopup, , , togglePopup] = useBinary()
  return (
    <div className="relative">
      <Button color="outlined" onClick={togglePopup}>
        <span className="block p-2">
          <MoreHorizIcon
            className="h-3 text-gray-600"
            aria-label={
              isOpenPopup
                ? 'アクションメニューを閉じる'
                : 'アクションメニューを開く'
            }
          />
        </span>
      </Button>
      <div className="absolute left-[-105px] top-[43px] z-shareModal">
        <Popup open={isOpenPopup} arrowPosition="right">
          <div className="w-[147px]">{children}</div>
        </Popup>
      </div>
    </div>
  )
}
